import { EvidenceDto } from "./evidence-dto";

export class DOCDocumentDto {
  name: string = "";
  index: number = 0;
  comment?: string;
  documentId: number = -1;
  linkedEvidences: EvidenceDto[] = [];
}
